var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-3 mt-5 pr-8",attrs:{"fluid":""}},[(!_vm.organizationSet)?_c('p',{staticClass:"text-h8 font-weight-light text-uppercase text-center"},[_vm._v(_vm._s(_vm.$t('homeMessage')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }